import {useLocation, useOutletContext} from "react-router-dom";

import {usePermitExtensionForm} from "permitextension/hooks";
import {PermitExtensionForm} from "./form";
import {FormCommentsField, FormContainer} from "base/form/components";
import {PermitApplicationDecisionFormFields} from "permitapplication/presentational/form";
import Stack from "@mui/material/Stack";

const PermitExtensionReportStep = () => {
    const {extension, isStepEditable} = useOutletContext();

    const basePath = useLocation();

    const {handleFormSubmit} = usePermitExtensionForm(extension, basePath);

    return (
        <PermitExtensionForm entity={extension} onSubmit={handleFormSubmit}>
            <Stack spacing={1}>
                <FormContainer>
                    <PermitApplicationDecisionFormFields disabled={!isStepEditable} />
                </FormContainer>
                <FormContainer>
                    <FormCommentsField
                        rows={5}
                        maxLength={5000}
                        attributeName="technical_comments"
                        label="Observações técnicas"
                        disabled={!isStepEditable}
                    />
                </FormContainer>
            </Stack>
        </PermitExtensionForm>
    );
};

export default PermitExtensionReportStep;
